import { Directive, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { NgModel } from '@angular/forms';
import { fromEvent } from 'rxjs';
import { map, debounceTime } from 'rxjs/operators';

@Directive({
  selector: '[ngModel][debounce]',
  standalone: false,
})
export class DebounceDirective {
  @Output()
  public onDebounce = new EventEmitter<any>();

  @Input('debounce')
  public debounceTime: number = 500;

  private isFirstChange: boolean = true;

  constructor(
    private elementRef: ElementRef,
    private model: NgModel
  ) {}

  ngOnInit() {
    const eventStream = fromEvent(this.elementRef.nativeElement, 'keyup').pipe(
      map((e: any) => {
        if (e.keyCode == 9 && e.key == 'Tab') {
          return 'false';
        } else {
          return this.model.value;
        }
      }),
      debounceTime(this.debounceTime)
    );

    // const blurStream = fromEvent(this.elementRef.nativeElement, 'blur')
    //     .pipe(
    //         map((e: any) => {
    //             console.log('========================blur', e, this.model.value)
    //             // if (e.keyCode == 9 && e.key == 'Tab') {
    //             //     return false;
    //             // } else {
    //                 return this.model.value;
    //             // }
    //         })
    //     )

    this.model.viewToModelUpdate = () => {};

    eventStream.subscribe(input => {
      if (input == 'false') {
      } else {
        this.model.viewModel = input;
        this.model.update.emit(input);
      }
    });

    // blurStream.subscribe(input => {
    //     // console.log('=================sdfjnsf-----blurStream', input)
    //     // if (input == false) {
    //     // } else {
    //         this.model.viewModel = input;
    //         this.model.viewModel = input;
    //         this.model.update.emit(input);
    //     // }
    // });
  }
}
